/**
 * Default chart-of-accounts cards.
 *
 * Mirrors the seed file served by the server at
 * `wwwroot/Resources/accountCards.csv`. Used to offer the standard account
 * cards as selectable options for sort-code Debit / Credit accounts while still
 * allowing a free numeric value to be typed in.
 */
const defaultAccountCards = [
    { cardId: '1', name: 'מע"מ עיסקאות' },
    { cardId: '2', name: 'מע"מ תשומות ציוד' },
    { cardId: '3', name: 'מע"מ תשומות' },
    { cardId: '4', name: 'הכנסות/מכירות/שכ"ט' },
    { cardId: '5', name: 'הכנסות לקבל תוצאתי' },
    { cardId: '6', name: 'הכנסות פטורות' },
    { cardId: '7', name: 'הכנסות מייבוא' },
    { cardId: '8', name: 'מכירת ציוד' },
    { cardId: '9', name: 'הכנסות רשות פלסטינית' },
    { cardId: '10', name: 'קניות רשות פלסטינית' },
    { cardId: '11', name: 'קניות מייבוא' },
    { cardId: '15', name: 'ניכוי מס במקור מלקוחות' },
    { cardId: '16', name: 'קניות חומרים' },
    { cardId: '17', name: 'עבודות חוץ-קבלני משנה' },
    { cardId: '18', name: 'הוצאות משרדיות' },
    { cardId: '19', name: 'אחזקה' },
    { cardId: '20', name: 'חשמל' },
    { cardId: '21', name: 'ארנונה ומים' },
    { cardId: '22', name: 'ביטוח עסק' },
    { cardId: '23', name: 'טלפון בזק' },
    { cardId: '24', name: 'טלפון סלולרי' },
    { cardId: '25', name: 'שליחויות והובלות' },
    { cardId: '26', name: 'מיקצועיות' },
    { cardId: '27', name: 'משפטיות' },
    { cardId: '28', name: 'ספרות מקצועית' },
    { cardId: '29', name: 'פרסום ושיווק' },
    { cardId: '30', name: 'אגרות ודמי חבר' },
    { cardId: '31', name: 'שכר דירה' },
    { cardId: '32', name: 'הוצאות רכב' },
    { cardId: '33', name: 'כיבוד ומתנות' },
    { cardId: '34', name: 'עמלות כרטיסי אשראי' },
    { cardId: '35', name: 'שכר עבודה' },
    { cardId: '36', name: 'ביטוח לאומי מעביד' },
    { cardId: '37', name: 'הוצאות גמל' },
    { cardId: '38', name: 'הוצאות פיצויים' },
    { cardId: '39', name: 'ריבית ועמלות בנקים' },
    { cardId: '40', name: 'הכנסות ריבית' },
    { cardId: '41', name: 'קבועות רכב' },
    { cardId: '42', name: 'אחזקת תוכנות ומחשבים' },
    { cardId: '43', name: 'נסיעות' },
    { cardId: '44', name: 'תרומות' },
    { cardId: '45', name: 'חניה' },
    { cardId: '46', name: 'החזר הוצאות' },
    { cardId: '47', name: 'הכנסות זקופות' },
    { cardId: '48', name: 'השתלמויות' },
    { cardId: '49', name: 'ביטוח רכבים' },
    { cardId: '50', name: 'הוצאות גמל אובדן כושר' },
    { cardId: '51', name: 'הוצאות שכירות רכב' },
    { cardId: '52', name: 'אחזקת רכב מסחרי' },
    { cardId: '53', name: 'ניכוי מס במקור מספקים' },
    { cardId: '54', name: 'שכירות רכב מסחרי' },
    { cardId: '55', name: 'כלי עבודה' },
    { cardId: '56', name: 'ביגוד והלבשה' },
    { cardId: '57', name: 'הוצאות מימון' },
    { cardId: '63', name: 'ניכוי מע"מ במקור מספקים' },
    { cardId: '65', name: 'מע"מ חו"ז' },
    { cardId: '66', name: 'מ.ה ניכויים חו"ז' },
    { cardId: '67', name: 'ביטוח לאומי חו"ז' },
    { cardId: '68', name: 'סולר רכב מסחרי' },
    { cardId: '101', name: 'רכישת ציוד' },
    { cardId: '102', name: 'רכוש קבוע' },
    { cardId: '103', name: 'פחת נצבר' },
    { cardId: '110', name: 'מלאי מאזני' },
    { cardId: '201', name: 'הכנסות לקבל מאזני' },
    { cardId: '202', name: 'שיקים לקבל' },
    { cardId: '500', name: 'קופת שיקים' },
    { cardId: '501', name: 'קופת מזומן' },
    { cardId: '502', name: 'קופת כרטיסי אשראי' },
    { cardId: '506', name: 'קניות פטורות' },
    { cardId: '510', name: 'בנק הפועלים' },
    { cardId: '511', name: 'בנק לאומי' },
    { cardId: '515', name: 'קופת העברות' },
    { cardId: '499', name: 'קופת קיזוזים' },
    { cardId: '520', name: 'פקדונות' },
    { cardId: '530', name: 'שיקים לפרעון' },
    { cardId: '540', name: 'הלוואות מבנקים' },
    { cardId: '600', name: 'הוצאות מראש' },
    { cardId: '601', name: 'הוצאות לשלם' },
    { cardId: '650', name: 'בעלי מניות' },
    { cardId: '651', name: 'הון מניות' },
    { cardId: '7200', name: 'פקדון' },
    { cardId: '7201', name: 'הוצאות' },
    { cardId: '7202', name: 'שונות' },
];

export default defaultAccountCards;
